import { Card, CardHeader, Avatar, CardContent, Typography, Box, useMediaQuery } from '@mui/material'
import { type CardProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { convertDateToFormattedString } from '../utils/dateTransfer'
import LogoSvg from '../layout/MainLayout/Header/Logo/LogoSvg'
import { getInitials } from '../utils/getInitials'

interface SupportPostProps extends CardProps {
  text?: string
  date: string
  isClient: boolean
  senderName: string
}

const SupportPost: React.FC<SupportPostProps> = ({ children, date, isClient, senderName }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  return (
    <Card sx={{ boxShadow: 0, borderRadius: 3, my: 1, px: isMobile ? 0 : 2, py: isMobile ? 0 : 1 }}>
          <CardHeader
          avatar={
              isClient
                ? <Avatar sx={{ bgcolor: '#e1f6f4', color: '#09B5EC', width: '50px', height: '50px' }} aria-label="User avatar">
              <Typography sx={{ fontSize: '14px', fontWeight: 900, color: '#09B5EC' }}>{getInitials(senderName)}</Typography>
            </Avatar>
                : <LogoSvg />
          }
          title={
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Typography variant='body2'>{isClient ? senderName : 'Support'}</Typography>
              <Typography variant='body2'>{convertDateToFormattedString(date)}</Typography>
            </Box>
          }
          />
          <CardContent sx={{ pt: 0 }}>
            <Typography variant="body1"
              sx={{
                color: theme.palette.grey[40],
                fontSize: '15px',
                fontWeight: 500,
                lineHeight: '30px',
                wordBreak: 'break-word'
              }}
            >
              { children }
            </Typography>
          </CardContent>
    </Card>
  )
}

export default SupportPost
